import { GetAllClubs } from '@/app/shared/services/clubService/clubService';

const clubStore = {
  state: {
    selectedClub: null,
    availableClubs: [],
  },

  mutations: {
    setAvailableClubs(state, value) {
      state.availableClubs = value;

      // Set default selected club if none is selected and clubs are available
      if (state.selectedClub === null && value && value.length > 0) {
        state.selectedClub = value[0];
      }
    },

    setSelectedClub(state, value) {
      if (value !== undefined) {
        state.selectedClub = value;
      }
    },
  },

  actions: {
    async setSelectedClub({ state, dispatch, commit }, value) {
      commit('setSelectedClub', value);
      dispatch('getAvailableCourses', state.selectedClub);
    },

    async getAvailableClubs({ state, dispatch, commit }) {
      await GetAllClubs().then(
        (data) => {
          commit('setAvailableClubs', data);
          if (state.selectedClub != null) dispatch('getAvailableCourses', state.selectedClub);
        },
        () => {

        },
      );
    },

  },

};

export { clubStore };
